import React, { useEffect, useRef, useState } from 'react';
import UilSignout from '@iconscout/react-unicons/icons/uil-signout';
import { Avatar } from 'antd';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { InfoWraper, UserDropDwon } from './auth-info-style';
import { Popover } from '../../popup/popup';
import Heading from '../../heading/heading';
import { logOut } from '../../../redux/authentication/actionCreator';
import { FaCamera } from "react-icons/fa";
import { DataService } from '../../../config/dataService/dataService';
import notifyUser from '../../notifications';

const AuthInfo = React.memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  // work on image upload
  const fileInputRef = useRef(null);
  const [avatarSrc, setAvatarSrc] = useState(
    require('../../../static/img/avatar/avatar.png')
  );

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const res = await DataService.get('/users/me');
        const userData = res?.data?.data;
        setUser(userData);

        if(userData?.profileImage){
          setAvatarSrc(userData?.profileImage); 
        }
      } catch (error) {
        const errMsg = error?.response?.data?.message || 'Profile data load nahi ho saka.';
        notifyUser(errMsg);
      }
    };
    fetchUserProfile();
  }, []);

  const handleBadgeClick = () => {
  fileInputRef.current.click();
 }

  const uploadFileToSpace = async (file) => {
    const preSignedRes = await DataService.post('/v1/pre-signed-url', {
      fileName: file.name,
    });
    
    const { signedUrl, url } = preSignedRes?.data?.data;
    
    if (!signedUrl) {
      throw new Error('Signed URL generated nahi ho paya.');
    }
  
    const response = await fetch(signedUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/octet-stream',
        'x-amz-acl': 'public-read',
      },
      body: file,
    });
  
    if(!response.ok){
      throw new Error('DigitalOcean par file upload fail ho gaya.');
    }
    return url;
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = null;
    const currentUserId = user?.id
    if(!currentUserId){
      notifyUser('user id not found');
      return;
    }
    console.log(currentUserId)
    try {
      setLoading(true);
      const uploadedUrl = await uploadFileToSpace(file);
      const payload = {
        profileImage: uploadedUrl
      }
      
      const res = await DataService.put(`/users/${currentUserId}`, payload);
      if(res?.data){
        setAvatarSrc(uploadedUrl)
      }
      setUser((prev) => ({ ...prev, profileImage: uploadedUrl }));
      notifyUser('success', 'Profile image successfully updated!', 'Success');
    } catch (error) {
      const errMsg = error?.response?.data?.message || 'Failed to upload profile picture';
      notifyUser(errMsg);
    } finally {
      setLoading(false);
    }
  };

    const SignOut = (e) => {
    e.preventDefault();
    dispatch(logOut(() => navigate('/')));
  };

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <figure className="user-dropdwon__info">
          <div className="avatar-wrapper">
            <img src={avatarSrc} alt=""/>
            <input type="file" ref={fileInputRef} onChange={handleFileChange} accept="image/*" style={{ display: 'none' }}/>
            <div className="upload-badge" title="Change Avatar" onClick={handleBadgeClick} style={{cursor: 'pointer'}}>
              <FaCamera className="upload-icon"  size={12} />
            </div>
          </div>
          <figcaption>
            <Heading as="h5">{user?.name}</Heading>
            <p>{user?.designation}</p>
          </figcaption>
        </figure>
        <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
          <UilSignout /> Sign Out
        </Link>
      </div>
    </UserDropDwon>
  );

  return (
    <InfoWraper>
      <div className="ninjadash-nav-actions__item ninjadash-nav-actions__author">
        <Popover placement="bottomRight" content={userContent} action="click">
          <Link to="#" className="ninjadash-nav-action-link">
            <Avatar src={avatarSrc} />
            <span className="ninjadash-nav-actninjadash-nav-actions__item ninjadash-nav-actions__author ions__author--name ">
              {user?.name}
            </span>
          </Link>
        </Popover>
      </div>
    </InfoWraper>
  );
});

export default AuthInfo;
